module.exports = __webpack_public_path__ + "img/shortLogo.3653fc6c.svg";